import React, { useState } from "react"
import { Box, Typography } from "@mui/material"
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"
import { motion } from "framer-motion"
import useTranslationSharie from "../hooks/Language/useTranslation"

// Example steps — customize the positions and texts

const Instructions = ({ onFinish }) => {
  const [stepIndex, setStepIndex] = useState(0)
  const t = useTranslationSharie()
  const steps = [
    { x: "50%", y: "5%", text: t("Click here to share your talent") },
    { x: "50%", y: "50%", text: t("It will be added to the feed of all talents") },
    { x: "90%", y: "5%", text: t("Check your Island with all your stuff") },
    { x: "25%", y: "5%", text: t("This Sphere is AI powered") },
  ]
  const step = steps[stepIndex]

  const handleClick = () => {
    if (stepIndex + 1 < steps.length) {
      setStepIndex((prev) => prev + 1)
    } else {
      onFinish?.()
    }
  }

  return (
    <Box
      onClick={handleClick}
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 9999,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(54, 79, 191, 0.6)",
        backdropFilter: "blur(6px)",
        cursor: "pointer",
        opacity: 0.7,
      }}
    >
      <motion.div
        initial={false}
        animate={{ left: step.x, top: step.y }}
        transition={{ duration: 0.6, ease: "easeInOut" }}
        style={{
          position: "absolute",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          pointerEvents: "none",
        }}
      >
        <ArrowForwardIcon
          sx={{
            color: "#fff",
            fontSize: 48,
            transform: step.x === "90%" ? "rotate(-90deg)" : "rotate(90deg)",
          }}
        />
        <Typography
          variant='subtitle1'
          sx={{
            mt: 1,
            color: "#fff",
            fontWeight: "bold",
            textAlign: "center",
            background: "rgba(0,0,0,0.2)",
            px: 2,
            py: 1,
            borderRadius: 2,
          }}
        >
          {step.text}
        </Typography>
      </motion.div>
    </Box>
  )
}

export default Instructions
